import React from "react";
import styled from "styled-components";
import { desktop } from "../../BreakPoints";
import { Footer } from "./elements/Footer";


export const NoNavigationPageWrapper: React.FunctionComponent = ({ children }) => {

    return (

        <Main>
            <LogoHanging>
                <img src="/images/amorg_logo_blue.svg" />
            </LogoHanging>
            <CoreContent className="mainContent">
                {children}
            </CoreContent>
            <CoreFooter>
                <Footer />
            </CoreFooter>
        </Main>

    )
};

const Main = styled.div`
    display:grid;
    min-height: 100%;
    grid-template-columns: 320px auto;
    grid-template-rows: auto min-content;
    grid-template-areas:
        "navigation content"
        "navigation footer";

    @media (max-width: ${desktop}px) {
        grid-template-columns: auto;
        grid-template-rows: 65px auto min-content;
        grid-template-areas:
        "navigation"
        "content"
        "footer";
    }
`;

const CoreContent = styled.div`
    background: white;
    padding-bottom:20px;
    position: relative;
    z-index: 10;
    grid-area: content;
`;

const CoreFooter = styled.div`
    grid-area: footer;
`;

const LogoHanging = styled.div`
    align-self: start;
    height: 100px;
    left: 20px;
    position: sticky;
    top: 20px;
    width: 100px;
    margin:0 auto;

    @media (max-width: ${desktop}px) {
        height: 50px;
        width: 50px;
    }
`;